import toastNotify from "./toastNotify";

export const getGeoLocation = async () => {
    try {
        if (navigator.geolocation) {
            const position: any = await getCurrentPosition();
            return {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            }
        } else {
            toastNotify('Geolocation is not supported by browser.', "error");
            return {
                latitude: "",
                longitude: "",
            };
        }
    } catch (error: any) {
        return {
            latitude: '',
            longitude: '',
        }
    }
};

const getCurrentPosition = () => {
    return new Promise((resolve, reject) => {
        const options = {
            timeout: 5000
        }
        navigator.geolocation.getCurrentPosition(resolve, reject, options)
    })
}